import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  updateProfile,
  User,
} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authFullName, setAuthFullName] = useState('');
  const [authError, setAuthError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoadingAuth(false);
      if (currentUser) {
        // If user is already logged in, redirect to home or account center
        navigate('/'); // Or wherever you want to redirect after login
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    setAuthError(null);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, authEmail, authPassword);
      await updateProfile(userCredential.user, {
        displayName: authFullName,
      });
      // No explicit redirect here, useEffect will handle it on auth state change
    } catch (error: any) {
      setAuthError(error.message);
    }
  };

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setAuthError(null);
    try {
      await signInWithEmailAndPassword(auth, authEmail, authPassword);
      // No explicit redirect here, useEffect will handle it on auth state change
    } catch (error: any) {
      setAuthError(error.message);
    }
  };

  if (loadingAuth) {
    return <div className="container mt-5">Loading authentication...</div>;
  }

  if (user) {
    return (
      <div className="container mt-5 text-center">
        <h2>You are already logged in!</h2>
        <p>Redirecting to home page...</p>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h5 className="card-title text-center mb-4">Sign In or Sign Up</h5>
            <form onSubmit={handleSignIn}>
              <div className="mb-3">
                <label htmlFor="authFullName" className="form-label">Full Name (for Sign Up)</label>
                <input type="text" className="form-control" id="authFullName" value={authFullName} onChange={(e) => setAuthFullName(e.target.value)} />
              </div>
              <div className="mb-3">
                <label htmlFor="authEmail" className="form-label">Email</label>
                <input type="email" className="form-control" id="authEmail" value={authEmail} onChange={(e) => setAuthEmail(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label htmlFor="authPassword" className="form-label">Password</label>
                <input type="password" className="form-control" id="authPassword" value={authPassword} onChange={(e) => setAuthPassword(e.target.value)} required />
              </div>
              {authError && <div className="text-danger mb-3">{authError}</div>}
              <div className="d-grid gap-2">
                <button type="submit" className="btn btn-primary">Sign In</button>
                <button type="button" className="btn btn-secondary" onClick={handleSignUp}>Sign Up</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;